import React, {lazy, useRef, useState} from 'react';
import {useTranslation} from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import {CAPTCHA_KEY} from "constants/config";
import useInput from "hooks/useInput";
import styled from "styled-components";
import StyledButton from "ui/StyledButton";
import {Email, Phone, Title} from "./RecoveryPasswordComponents";
import HeaderOne from 'components/customText/headers/HeaderOne';
import {updateAlert, updateModalCheckEmail, updateModalCheckPhone} from "redux/reducers/appSlice";
import {useTypedDispatch, useTypedSelector} from "hooks/useTypedRedux";
import {useCreateRecoverySessionEmailMutation, useCreateRecoverySessionMutation} from "redux/api/userApi";
import {ValidationEmail, ValidationPhoneNumber} from "constants/validations";
import {selectThemeType} from "redux/selectors/appSelector";
import {ProjectSettings} from "config";

const CheckPhoneModal = lazy(() => import('../modal/CheckPhoneModal'))
const CheckEmailModal = lazy(() => import('../modal/CheckEmailModal'))

interface ResetPasswordProps {
    isDesktop?: boolean
}

const ResetPasswordWrapper = (props: ResetPasswordProps) => {

    const {isDesktop = true} = props

    const variant = ProjectSettings.variant()

    const dispatch = useTypedDispatch()
    const theme_type = useTypedSelector(selectThemeType)

    const {t} = useTranslation();

    const [createRecoverySession] = useCreateRecoverySessionMutation()
    const [createRecoverySessionEmail] = useCreateRecoverySessionEmailMutation()

    const recaptchaRef = useRef<any>();
    const [captcha, setCaptcha] = useState<boolean>(false);

    const phoneNumber = useInput('', ValidationPhoneNumber);
    const email = useInput('', ValidationEmail);

    const onChange = (value: string | null) => {
        // console.log(value)
        value != null ? setCaptcha(true) : setCaptcha(false)
    }

    const ButtonStyle = `
        height: 40px;
        max-width: 250px;
    `

    const SendLink = () => {
        if (variant === 'lettobet') {
            if (!email.test()) {
                email.setErrorText(t(`common.registration.enter_email`))
            } else {
                createRecoverySessionEmail({email: email.value})
                    .then((pld: any) => {
                        if ('data' in pld) {
                            dispatch(updateAlert({
                                isOpen: true,
                                status: "success",
                                message: t(`common.alert.status_warning`)
                            }))
                            dispatch(updateModalCheckEmail())
                        }
                        if ('error' in pld) {
                            email.setErrorText(t(`common.error.${pld.error.data.code}`))
                        }
                    })
                    .catch((pld: any) => {
                        email.setErrorText(t(`common.error.${pld.error.data.code}`))
                    })
            }
        } else {
            if (!phoneNumber.test()) {
                phoneNumber.setErrorText(t(`common.registration.phone.enter_phone`))
            } else {
                createRecoverySession({phone: `+216${phoneNumber.value}`})
                    .then((pld: any) => {
                        if ('data' in pld) {
                            dispatch(updateAlert({
                                isOpen: true,
                                status: "success",
                                message: t(`common.alert.status_warning`)
                            }))
                            dispatch(updateModalCheckPhone())
                        }
                        if ('error' in pld) {
                            phoneNumber.setErrorText(t(`common.error.${pld.error.data.code}`))
                        }
                    })
                    .catch((pld: any) => {
                        phoneNumber.setErrorText(t(`common.error.${pld.error.data.code}`))
                    })
            }
        }
    }

    console.log(variant)

    return (
        <>
            {isDesktop
                ?
                <HeaderOne color={'black'} style={{marginTop: '25px', textTransform: 'uppercase'}}>
                    {t(`pages.recovery_password.reset_password`)}
                </HeaderOne>
                :
                <Title title={t(`pages.recovery_password.reset_password`)}/>
            }

            <Container>


                {variant !== 'lettobet'
                    ? <Phone phoneNumber={phoneNumber}/>
                    : <Email email={email}/>
                }

                {/*// @ts-ignore*/}
                {variant !== 'lettobet' && <ReCAPTCHA
                    theme={theme_type === 'light' ? 'light' : 'dark'}
                    id={'reset_password_recaptcha'}
                    ref={recaptchaRef}
                    sitekey={CAPTCHA_KEY.CLIENT_KEY}
                    onChange={onChange}
                />}

                <StyledButton
                    onClick={() => {
                        if (variant !== 'lettobet') {
                            recaptchaRef.current.reset();
                            setCaptcha(false);
                        }
                        SendLink();
                    }}
                    isDisabled={variant !== 'lettobet' && !captcha} extra={ButtonStyle}
                    id={'reset_password_button'}>
                    {t(`pages.recovery_password.reset_password`)}
                </StyledButton>

            </Container>

            {variant === 'goodwin' &&
                <CheckPhoneModal/>
            }
            {variant === 'lettobet' &&
                <CheckEmailModal/>
            }

        </>
    );
};

export default ResetPasswordWrapper;


const Container = styled.div`
  width: 248px;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & > * + * {
    margin-top: 30px;
  }
`